import {Component, Input} from '@angular/core';

@Component({
  selector: 'banner',
  templateUrl: 'banner.html'
})
export class BannerComponent {

  @Input() text;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/banner/banner.ts